export default __webpack_public_path__ + "static/media/Stock_Exchange_of_Thailand_logo.3df99a16.svg";